import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

interface TestimonialData {
	id: number;
	username: string;
	quote: string;
}

export const Testimonial = () => {
	const testimonials: TestimonialData[] = [
		{
			id: 1,
			username: 'Grace Mooney',
			quote: 'Our Children have been using Childs play services for many years, and they absolutely love it. As a parent I appreciate it for so many practical reasons it is incredibly convenient, the kids are collected from school, and I know they are in safe, capable hands.'
		},
		{
			id: 2,
			username: 'Ruth Hogan',
			quote: 'A testimonial from my son Lewis: I Love going to Childs play breakfast club and After school. It is so much fun because I get to play football with my friends every day.'
		},
		{
			id: 3,
			username: 'Aoife Condron',
			quote: 'Aislings feel like home away from home, all 3 of my girls have attended Childs play afterschool, they have all enjoyed it to mix with other aged children, engage in group activities like games and drama.'
		},
		{
			id: 4,
			username: 'Rachael Scally',
			quote: 'All 3 of my children- and hopefully the fourth when the time comes- have been luck to attend and avail of both pre school and after school. To say the staff, go above and beyond for the welfare and development of their young wards would be an understatement.'
		},
		{
			id: 5,
			username: 'Lorna & Joe Dooley',
			quote: 'Our Four Children absolutely loved their time at Childs play spanning the past 15 years. Aisling and the staff are caring, creative and truly invested in every child\'s growth.'
		},
		{
			id: 6,
			username: 'Sheena Daniels',
			quote: 'My Two boys attended / Currently attend Childs play Pre – School and my oldest still talks about his great days with the girls and always wants to go back for a visit.'
		},
		{
			id: 7,
			username: 'Patricia & John Dunne',
			quote: 'All Three of my children, Aisling Colm and Ava have loved their time at Childs play, From pre-school right through to the after-school programme. The atmosphere is always so warm welcoming and nurturing.'
		},
		{
			id: 8,
			username: 'Kat Sikora',
			quote: 'Child play Breakfast club is fantastic. Victoria plays with her friends every morning and she loves being there. Absolutely fantastic, caring and understanding staff.'
		},
		{
			id: 9,
			username: 'Sarah Murphy',
			quote: 'My daughter has thrived at Childs play. The caring staff and engaging activities have helped her develop confidence and social skills. We couldn\'t be happier with our choice.'
		}
	];

	return (
		<div className="bg-[#f3e5f5]">
		<section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#f3e5f5]">
			<div className="body-container">
				 {/* Header Section */}
				 <div className="mb-12">
          <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
            <div className="flex-1">
              {/* <p className="text-gray-400 text-sm uppercase tracking-wider font-semibold mb-4 font-['DM_Sans']">
                WHAT PARENTS SAY
              </p> */}
			  <button className="button-offer">What Parents Say</button>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 font-['Quicksand']">
                Genuine feedback from our satisfied parents
              </h2>
            </div>
            <div className="flex-1 lg:max-w-md">
              <p className="text-gray-700 text-base md:text-lg font-['DM_Sans']">
                Hear from real parents who trusted us with their children's care. Their honest feedback reflects the quality we consistently deliver.
              </p>
            </div>
          </div>
        </div>
				{/* Testimonials Grid */}
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
					{testimonials.map((testimonial) => (
						<div
							key={testimonial.id}
							className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col"
						>
							{/* Username */}
							<h3 className="text-gray-900 font-bold text-base mb-3 font-['DM_Sans']">
								{testimonial.username}
							</h3>

							{/* Star Rating */}
							<div className="flex items-center mb-3">
								{[...Array(5)].map((_, i) => (
									<FontAwesomeIcon
										key={i}
										icon={faStar}
										className="w-4 h-4 text-yellow-400"
									/>
								))}
							</div>

							{/* Review Text */}
							<p className="text-gray-600 text-sm leading-relaxed font-['DM_Sans']">
								{testimonial.quote}
							</p>
						</div>
					))}
				</div>
			</div>
		</section>
		</div>
	);
};

export default Testimonial;